import type { ReactNode } from "react";
import { renderMarkdown } from "../markdown";
import { BotBubble } from "./bubbles";
import { FollowUps } from "./chat-log";

export interface GreetingBubbleProps {
  /** Assistant name above the bubble. */
  name: string;
  avatar?: ReactNode;
  /** The agent's welcome message (markdown). Empty renders nothing. */
  message: string;
  /** Starter questions, shown as chips under the greeting. */
  starters?: readonly string[];
  onAsk?: (text: string) => void;
  /** Disables the chips while connecting or while an answer streams. */
  busy?: boolean;
  startersLabel?: string;
  className?: string;
}

/**
 * The agent's welcome message as the first assistant bubble, followed by its starter questions
 * as chips. UI-only: it is never part of the conversation state, never sent to the model as
 * history and never counted as an answer — surfaces render it above the real messages.
 */
export function GreetingBubble({ name, avatar, message, starters = [], onAsk, busy, startersLabel, className }: GreetingBubbleProps) {
  if (!message.trim()) return null;
  return (
    <div data-chat-greeting className={className}>
      <BotBubble name={name} avatar={avatar} after={onAsk ? <FollowUps items={starters} onAsk={onAsk} disabled={busy} label={startersLabel} /> : null}>
        {renderMarkdown(message)}
      </BotBubble>
    </div>
  );
}
